import {
  QrCode,
  UtensilsCrossed,
  Nfc,
  Link2,
  Bot,
  Phone,
} from "lucide-react";
import { FaGoogle, FaFacebookF, FaInstagram, FaWhatsapp, FaWordpress } from "react-icons/fa";

// Single source of truth for the Agency OS product bundle - shared by the
// homepage showcase and the full Agency OS page. Order matters: within each
// `category`, products render in the sequence listed below.
export const PRODUCTS = [
  // AI Automation
  {
    Icon: FaGoogle,
    color: "#4285F4",
    tint: "rgba(66,133,244,0.10)",
    name: "Google Business Profile Automation",
    desc: "AI review replies, bulk posts, Q&A and local rank tracking - your clients' Google presence on autopilot.",
    category: "AI Automation",
  },
  {
    Icon: FaFacebookF,
    color: "#1877F2",
    tint: "rgba(24,119,242,0.10)",
    name: "Facebook Automation",
    desc: "Cross-posting, a Messenger AI assistant and auto-comment replies that capture leads 24/7.",
    category: "AI Automation",
  },
  {
    Icon: FaInstagram,
    color: "#fff",
    gradient: "linear-gradient(135deg,#F58529,#DD2A7B,#8134AF)",
    name: "Instagram Automation",
    desc: "Reel scheduling, DM lead routing and story-mention triggers that turn engagement into pipeline.",
    category: "AI Automation",
  },
  {
    Icon: FaWhatsapp,
    color: "#25D366",
    tint: "rgba(37,211,102,0.12)",
    name: "WhatsApp API CRM",
    desc: "Bulk messages, broadcast campaigns, 24/7 auto replies and a chatbot that captures leads and books appointments on WhatsApp.",
    category: "AI Automation",
  },
  {
    Icon: Phone,
    color: "#7C3AED",
    tint: "rgba(124,58,237,0.10)",
    name: "AI Calling",
    desc: "AI voice agents that answer and make calls, qualify leads and book appointments around the clock.",
    category: "AI Automation",
  },
  {
    Icon: FaWordpress,
    color: "#21759B",
    tint: "rgba(33,117,155,0.10)",
    name: "WordPress Automation",
    desc: "Auto-synced review widgets and AI content mirroring that keep client sites fresh and ranking.",
    category: "AI Automation",
  },
  {
    Icon: Bot,
    color: "#16A34A",
    tint: "rgba(22,163,74,0.10)",
    name: "AEO + GEO Automation",
    desc: "Optimize for AI answer engines and generative search so clients get found in the next era of discovery.",
    category: "AI Automation",
  },

  // Software
  {
    Icon: QrCode,
    color: "#FF6B00",
    tint: "rgba(255,107,0,0.10)",
    name: "MagicQR + Review & Feedback",
    desc: "Dynamic QR codes that intercept feedback - unhappy customers go private, happy ones post to Google, Zomato & more.",
    category: "Software",
    subcategory: "QR",
  },
  {
    Icon: UtensilsCrossed,
    color: "#EF4444",
    tint: "rgba(239,68,68,0.10)",
    name: "Digital Menu",
    desc: "Live, editable digital menus and catalogs with visual upselling - updated instantly from a phone.",
    category: "Software",
    subcategory: "QR",
  },
  {
    Icon: Nfc,
    color: "#7C3AED",
    tint: "rgba(124,58,237,0.10)",
    name: "Digital Visiting Card",
    desc: "NFC-enabled digital business cards that share contacts, socials and review links with a single tap.",
    category: "Software",
    subcategory: "QR",
  },
  {
    Icon: Link2,
    color: "#8B5CF6",
    tint: "rgba(139,92,246,0.10)",
    name: "Bio Links",
    desc: "A Linktree-style bio page for socials - unlimited buttons, custom branding and click analytics.",
    category: "Software",
    subcategory: "QR",
  },
];
